import React from 'react';
import { Toast } from 'common-package';
import { Input } from 'antd';
import cx from './index.module.scss';

interface TextAreaProps {
  value?: string;
  onChange?: (value: string) => void;
  placeHolderText?: string;
  maxLength?: number;
}

const TextArea: React.FC<TextAreaProps> = (props: TextAreaProps) => {
  const { value, onChange, placeHolderText, maxLength } = props;

  return (
    <div className={cx('textArea')}>
      <Input.TextArea
        placeholder={placeHolderText}
        value={value}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
          if (event.target.value?.length > maxLength) {
            Toast.show('最多可填写40字符');
          } else {
            onChange(event.target.value as string);
          }
        }}
      />
      <div className={cx('text-num')}>
        <span className={cx('current-num')}>{value?.length || 0}</span>
        <span> / </span>
        <span>{maxLength}</span>
      </div>
    </div>
  );
};

export default TextArea;
